module.exports = __webpack_public_path__ + "img/W7036-full.08370145.jpg";